import BasicSelect from "./BasicSelect";
import MultiSelect from "./MultiSelect";

const Select = {
  BasicSelect,
  MultiSelect,
};

export default Select;
